import { useState } from "react";
import { OrderForm } from "../components/OrderForm";
import { api } from "../lib/api";
import type { OrderPayload } from "../types";

export function AddOrder() {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [resetKey, setResetKey] = useState(0);

  async function submit(order: OrderPayload) {
    setBusy(true);
    setError("");
    setMessage("");

    try {
      await api.createOrder(order);
      setMessage("订单已保存");
      setResetKey((value) => value + 1);
    } catch (err) {
      setError(err instanceof Error ? err.message : "保存失败");
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="page-stack">
      <header className="page-header">
        <div>
          <p className="eyebrow">Add Order</p>
          <h1>手动新增订单</h1>
        </div>
      </header>

      {message ? <div className="notice success">{message}</div> : null}
      {error ? <div className="notice danger">{error}</div> : null}

      <section className="panel">
        <OrderForm busy={busy} key={resetKey} onSubmit={submit} />
      </section>
    </section>
  );
}
